import { Tree } from 'react-arborist'
import classNames from "classnames";
import React, {FocusEvent, KeyboardEvent, useCallback, useEffect, useRef, useState} from "react";
import {ChevronDown, ChevronLeft, ChevronRight, ChevronUp, FileText, Folder} from "react-feather";
import {Plus} from 'react-feather';
import { NodeHandlers } from "react-arborist";
import { NodeRendererProps } from 'react-arborist/dist/types';
import { addCategoryItem, buildCategoryItem, CategoryTree, getCategoryTree } from '../repository/CategoryTree.repo';
import { click } from '@testing-library/user-event/dist/click';
import { mockComponent } from 'react-dom/test-utils';
import { Article, getArticles } from '../repository/Article.repo';
import { ArticleForm } from './Article';
import { ReactComponent as FolderSVG } from '../assets/images/folder.svg'
import { ReactComponent as TextSVG } from '../assets/images/file-text.svg'
import withReactContent from "sweetalert2-react-content";
import Swal from 'sweetalert2'
import {Backdrop, CircularProgress, Grid, MenuItem, Select, TextField} from "@mui/material";
import SelectInput from "@mui/material/Select/SelectInput";
import CategoryForm from "./CategoryForm";
import {LogIn, LogOut} from 'react-feather';
import {Folder as FolderIcon} from 'react-feather';
import axios from "axios";
import ViewBox from "./ViewBox";
import LoginNow from "../repository/login.repo";
import {ArticleView} from "./ArticleView";
import LanguageTab from "../LanguageTab";
const SAlert = withReactContent(Swal)

export function TreeView() {

  return (
    <div>
      {Element()}
    </div>
  )
}


function Element() {

  const [clicked, setClicked] = useState<number | null>()
  const [clickedArticle, setClickedArticle] = useState<number>()
  const [categoryTree, setMockData] = useState<CategoryTree[]>([])
  const [articles, setArticles] = useState<Article[]>([]);
  const [createCategoryOpen, setCreateCategoryOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loginView, setLoginView] = useState(false);
  const [loggedIn, setLoggedIn] = useState<any>(undefined);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [searchType, setSearchType] = useState('category');
  const [search, setSearch] = useState('')
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [activeLanguage, setActiveLanguage] = useState('de');


  //@ts-ignore
  const executeScroll = () => scrollRef.current?.scrollIntoView(true)

  useEffect(() => {

   if(window.location.pathname === '/login'){
     setLoginView(true);
   }

  }, []);

  useEffect(() => {
    if(window.location.pathname === '/logout'){
      localStorage.removeItem('token');
        setLoggedIn(undefined);
    }
  },[]);


  useEffect(() => {


    if(loggedIn !== undefined){
      //@ts-ignore
      axios.defaults.headers.common['Authorization'] = `Bearer ${loggedIn.access_token}`;
      localStorage.setItem('token', loggedIn.access_token);
    }else{
      delete axios.defaults.headers.common['Authorization'];
      const getItem = localStorage.getItem('token');

      if(getItem !== null){
        setLoggedIn({access_token: getItem});
      }
    }
  }, [loggedIn]);

  useEffect(() => {
    onUpdateSomething().then(undefined);
  }, []);

  const onUpdateSomething = useCallback(async (ID?:number) => {
    if(ID === -1){
      setClicked(getParent(categoryTree, clicked)?.ParentID);
    }
    setIsLoading(true);
    await getCategoryTree().then(res => {
      setMockData(res)
    })
    await getArticles().then(res => {
      setArticles(res)
    });

    if(ID !== undefined && ID !== -1){
        setCreateCategoryOpen(false);
        setClicked(ID);
    }

    setIsLoading(false);
  }, [categoryTree, clicked]);


  const loginNow = useCallback(async () => {

      const login = await LoginNow(email, password).catch((err) => {
        SAlert.fire({
          title: "Error",
          html: "Please check email & password",
          icon: "error"
        });
        return false;
      })

      if(!login){
        return;
      }
      window.location.href = '/'
      setLoggedIn(login);
      setLoginView(false);
  }, [email, password]);

  return (
    <div style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'row', cursor: 'pointer', position: "relative" }}>
      <Backdrop
          open={isLoading}
          sx={{ color: "#FFE16A", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="menuClass">

        <div style={{
          height: 60,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>

          <div style={{
            width: '100%',
            height: '100%',
            color: "#505050",
            fontSize: 25,
            fontWeight: "bold",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            WIKI ISLAM
          </div>
          <LanguageTab onChange={setActiveLanguage} activeLanguage={activeLanguage} />
          {/*<div onClick={() => {*/}
          {/*  if(loggedIn){*/}
          {/*    localStorage.removeItem('token');*/}
          {/*    setLoggedIn(undefined);*/}
          {/*  }else{*/}
          {/*    setLoginView(!loginView)*/}
          {/*  }*/}
          {/*}} style={{marginRight: 25}}>*/}
          {/*  {loggedIn === undefined ? <LogIn /> : <LogOut />}*/}
          {/*</div>*/}

        </div>
        {clicked !== undefined &&
          <div style={{display: "flex", justifyContent: "center"}}>
              <div
                onClick={() => {
                  setClicked(getParent(categoryTree, clicked)?.ParentID);
                  setCreateCategoryOpen(false); setClickedArticle(undefined) }}
                className="backButton">
              <div style={{marginRight: 5 }}>
                {<ChevronLeft width={18} height={18} />}
              </div>
              <div>
                Zurück
              </div>
            </div>
          </div>}

        <div style={{width: '100%', justifyContent: "center", marginBottom: 10, marginTop: 10}}>
          {/*<div style={{display: "flex", justifyContent: "center"}}>*/}
          {/*  <div onClick={() => setSearchType('category')} style={{ borderBottom: searchType === 'category' ? '1px solid #000' : "none", backgroundColor: '#fff', height: 40, width: 120, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#000'}}> Category</div>*/}
          {/*  <div onClick={() => setSearchType('article')} style={{ borderBottom: searchType === 'article' ? '1px solid #000' : "none",  backgroundColor: '#fff', height: 40, width: 120, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#000' }}> Article</div>*/}
          {/*</div>*/}
          <input onChange={(event) => setSearch(event.target.value)}  className="searchBar" placeholder={"Search"}/>
        </div>


        {getElements(search)}
        <div ref={scrollRef}>
          {contentData(true)}
        </div>

      </div>

      {contentData(false)}

    </div>
  )


  function contentData(mobileOnly: boolean) {
   return (
       <div className={`contentClass ${mobileOnly && 'mobile'}`}>
       {loginView ? (
             <ViewBox>
               <Grid
                   container
                   spacing={2}
                   sx={{
                     minHeight: '100%',
                     width: '100%'
                   }}
               >
                 <Grid item md={12} xs={12} sm={12}>
                   <ViewBox title={''}>
                     <TextField id="outlined-basic full-width" onChange={(e) => setEmail(e.target.value)} value={email} label="E-MAIL" variant="outlined" />
                   </ViewBox>
                 </Grid>
                 <Grid item md={12} xs={12} sm={12}>
                   <ViewBox title={''}>
                     <TextField id="outlined-basic full-width" onChange={(e) => setPassword(e.target.value)} value={password} type={"password"} label="Password" variant="outlined" />
                   </ViewBox>
                 </Grid>
                 <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: 20}}>
                   <div style={{ backgroundColor: 'green', height: 40, width: 120, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', borderRadius: 8 }} onClick={loginNow}>LOGIN</div>
                 </div>

               </Grid>
             </ViewBox>
         ) : (
             <React.Fragment>

               <div className="breadCrumb">
                 <ul>
                   {getParentHistory(categoryTree, clicked).map((i:any, index:number) => (
                       <li onClick={() => setClicked(i.id)}>{i.name} {getParentHistory(categoryTree, clicked).length -1 !== index &&(<ChevronRight width={15} height={15} style={{height: 12}} />)}</li>
                   ))}
                 </ul>
               </div>
               {loggedIn ? (
                   <React.Fragment>
                     {clickedArticle &&
                         <ArticleForm currentParent={clicked !== undefined ? clicked : undefined} categories={categoryTree} setIsLoading={setIsLoading} onUpdate={onUpdateSomething} article={articles.find(art => art.ID === clickedArticle)} />
                     }
                     {(createCategoryOpen || (clicked !== undefined && clickedArticle === undefined)) &&
                         <CategoryForm setIsLoading={setIsLoading} onUpdate={onUpdateSomething} categories={categoryTree} currentParent={clicked !== undefined ? clicked : undefined} category={createCategoryOpen ? undefined : categoryTree.find((cat) => cat.ID === clicked)} />
                     }
                   </React.Fragment>
               ): (
                   <React.Fragment>
                     {clickedArticle &&
                         <ArticleView activeLanguage={activeLanguage} article={articles.find((art) => art.ID === clickedArticle)} />
                     }
                   </React.Fragment>
               )}


             </React.Fragment>

         )}

       </div>
   )
  }

  function getElements(search?: string) {

    let categoryData = categoryTree;
    let articleData = articles;
    let searchStatus = false;
    if(search !== '' && search !== null && search !== undefined){
      const searchText = search.toLocaleLowerCase();
      searchStatus = true;
        categoryData = categoryData.filter((item) => {
          return  item.Name.toLocaleLowerCase().includes(searchText) || item.Tags.toLocaleLowerCase().includes(searchText) || item.Description.toLocaleLowerCase().includes(searchText);
        });
        articleData = articleData.filter((item) => {
          return item.Name.toLocaleLowerCase().includes(searchText) || item.Tags.toLocaleLowerCase().includes(searchText) || item.Description.toLocaleLowerCase().includes(searchText) || item.Author.toLocaleLowerCase().includes(searchText);
        })

    }

    return (
      <div>
        {searchStatus ? (
            <React.Fragment>

                  <>
                    {
                      categoryData.map(element => {
                        return categoryItem(element)
                      })
                    }
                  </>
                  <>
                    {
                      articleData.filter(ele => ele.ArticleCategories.length !== 0).map(element => {
                        return articleItem(element);
                      })
                    }
                  </>

            </React.Fragment>
        ): (
          <React.Fragment>
            {
              categoryData.filter(ele => clicked ? ele.ParentID === clicked : ele.ParentID === null).map(element => {
                return categoryItem(element)
              })
            }
            {
              articleData.filter(ele => clicked ? ele.ArticleCategories.map(i => i.category_id).includes(clicked) : loggedIn ? ele.ArticleCategories.length === 0 : false).map(element => {
                return articleItem(element);
              })
            }
            {loggedIn && (
                <React.Fragment>
                  <div onClick={() => {
                    localStorage.removeItem('token');
                    setLoggedIn(undefined);
                  }} className="logOutButton" >
                    <LogOut size={20} />
                  </div>
                  <div onClick={() => { addItem() }} className="plusButton" >
                    <Plus size={50} />
                  </div>
                </React.Fragment>

                )}


            <div onClick={() => { document.body.scrollTo(0, 0) }} className="scrollTop" >
              <ChevronUp size={25} />
            </div>


          </React.Fragment>
        )}


      </div >
    )
  }


  function categoryItem(element: CategoryTree){

    let name = element.Name;
    if(activeLanguage !== 'de'){
      //@ts-ignore
      const elementText = element.CategoryTreeLanguage?.find((item) => item.lang === activeLanguage);
      if(elementText){
        name = elementText.Name
      }else{

      }

    }


    return (
        <div className="menuItem" onClick={() => { setClicked(element.ID); setCreateCategoryOpen(false); setClickedArticle(undefined) }}
             style={{ width: '100%', color: "#505050", height: 60, border: '#000 solid 1px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

          <div style={{display: "flex", justifyContent: "space-around", alignItems: "center", paddingLeft: 20}}>
            <div className="icon" style={{alignContent: "center", height: 26, marginRight: 15}}>
              < FolderIcon />
            </div>
            <div className="title">
              {name}
            </div>
          </div>

          <div className="icon" style={{paddingRight: 20}}>
            {<ChevronRight  />}
          </div>
        </div >
    )
  }


  function articleItem(element: Article){


    let name = element.Name;
    if(activeLanguage !== 'de'){
      //@ts-ignore
      const elementText = element.ArticleLanguage?.find((item) => item.lang === activeLanguage);
      if(elementText){
        name = elementText.Name
      }

    }

    return (
        <div className="menuItem" onClick={() => {
          setClickedArticle(element.ID);
          setCreateCategoryOpen(false);
          if(window.innerWidth <= 768){
            setTimeout(executeScroll, 100)
          }
        }}
             style={{ width: '100%', height: 60, border: '#000 solid 1px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

          <div style={{display: "flex", justifyContent: "space-around", alignItems: "center", paddingLeft: 20}}>
          <div style={{height: 26, marginRight: 15}} className="icon">
            <TextSVG />
          </div>
          <div className="title">
            {name}
          </div>
          </div>
        </div >
    )

  }

  function createArticlePusher(){
    setClickedArticle(-14);
    SAlert.close();
  }

  function createCategoryPusher(){
    setCreateCategoryOpen(true);
    setClickedArticle(undefined);
    SAlert.close();
  }

  function addItemSelectionView() {

    return (
        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-around", alignItems: "center"}}>
          <div style={{ backgroundColor: 'darkgreen', cursor: "pointer", height: 40, width: 120, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', borderRadius: 8 }} onClick={createCategoryPusher}> Category</div>
          <div style={{ backgroundColor: 'midnightblue', height: 40, cursor: "pointer", width: 120, marginLeft: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', borderRadius: 8 }} onClick={createArticlePusher}> Article</div>
        </div>
    )


  }

  function addItem() {

    SAlert.fire({
      title: 'Please Select',
      html: addItemSelectionView(),
      showConfirmButton: false,
      showCancelButton: false
    });

    //let newItem = [buildCategoryItem('addedElemet', 'I have been added ', clicked ? clicked : null, ['tag', 'tag2', 'tag3'], categoryTree)]
    //setMockData(categoryTree.concat(newItem))
  }


  function hasTheElementChild(data: CategoryTree[], id: number) {
    return data.filter(ele => ele.ParentID === id).length === 0
  }

  function getParent(data: CategoryTree[], id: number | undefined | null): CategoryTree | undefined {
    let found = data.find(ele => ele.ID === id)
    if (found && found.ParentID !== null) {
      return found
    } else {
      return undefined
    }
  }

  function getParentHistory(data: CategoryTree[], id: number | undefined | null): any {
    const itemList = [];
    if (id) {
      let currentClickedElement = data.find(ele => ele.ID === id)
      let parentID = currentClickedElement?.ParentID
      let parentHistory = currentClickedElement?.Name
      let index = 0
      itemList.push({id: currentClickedElement?.ID, name: currentClickedElement?.Name});
      while (parentID !== null) {
        index += 1
        currentClickedElement = data.find(ele => ele.ID === parentID)
        parentID = currentClickedElement?.ParentID
        itemList.push({id: currentClickedElement?.ID, name: currentClickedElement?.Name});
        parentHistory = currentClickedElement?.Name + '-----' + parentHistory
      }
      return itemList.reverse();
      return parentHistory ? parentHistory : ''
    } else {
      return []
    }
  }

}

